import dayjs from "dayjs";

// ヘルパー関数を使って、複数の要素を一度に取得
const getElements = (ids: string[]): HTMLInputElement[] => ids.map((id) => document.querySelector(`#${id}`) as HTMLInputElement);

const getCurrentMonthRange = (): { start: string; end: string } => {
  const now = dayjs();
  return {
    start: now.startOf("month").format("YYYY-MM-DD"),
    end: now.endOf("month").format("YYYY-MM-DD"),
  };
};

const getMonthRange = (date: string): { start: string; end: string } => {
  const baseDate = dayjs(date);
  return {
    start: baseDate.startOf("month").format("YYYY-MM-DD"),
    end: baseDate.endOf("month").format("YYYY-MM-DD"),
  };
};

const setMonthRange = (startDateInput: HTMLInputElement, endDateInput: HTMLInputElement, start: string, end: string) => {
  startDateInput.value = start;
  endDateInput.value = end;
};

// < (前月) ボタンを押したときの処理
const handlePrevMonth = (startDateInput: HTMLInputElement, endDateInput: HTMLInputElement) => {
  const currentStartDate = startDateInput.value || dayjs().format("YYYY-MM-DD");
  const previousMonthDate = dayjs(currentStartDate).subtract(1, "month");
  const { start, end } = getMonthRange(previousMonthDate.format());
  setMonthRange(startDateInput, endDateInput, start, end);
};

// 今月ボタンを押したときの処理
const handleCurrentMonth = (startDateInput: HTMLInputElement, endDateInput: HTMLInputElement) => {
  const { start, end } = getCurrentMonthRange();
  setMonthRange(startDateInput, endDateInput, start, end);
};

// > (来月) ボタンを押したときの処理
const handleNextMonth = (startDateInput: HTMLInputElement, endDateInput: HTMLInputElement) => {
  const currentStartDate = startDateInput.value || dayjs().format("YYYY-MM-DD");
  const nextMonthDate = dayjs(currentStartDate).add(1, "month");
  const { start, end } = getMonthRange(nextMonthDate.format());
  setMonthRange(startDateInput, endDateInput, start, end);
};

const apply = (): void => {
  const [prevMonthButton, currentMonthButton, nextMonthButton, startDateInput, endDateInput] = getElements([
    "prev-month",
    "current-month",
    "next-month",
    "q_inspected_on_gteq",
    "q_inspected_on_lteq",
  ]);

  if (!(prevMonthButton && currentMonthButton && nextMonthButton && startDateInput && endDateInput)) return;

  prevMonthButton.addEventListener("click", (event) => {
    event.preventDefault();
    handlePrevMonth(startDateInput, endDateInput);
  });

  currentMonthButton.addEventListener("click", (event) => {
    event.preventDefault();
    handleCurrentMonth(startDateInput, endDateInput);
  });

  nextMonthButton.addEventListener("click", (event) => {
    event.preventDefault();
    handleNextMonth(startDateInput, endDateInput);
  });
};

const initialInspectedRangeSelect = (): void => {
  document.addEventListener("turbo:load", apply);
};

export default initialInspectedRangeSelect;
